export default "__VITE_ASSET__bfcc7458__"